<div *ngIf="configuration === undefined">Loading node configuration...</div>
<div [hidden]="configuration === undefined" class="node-configuration-container">
    <div *ngIf="configuration !== undefined && readMode" class="node-configuration-readmode">
        Some items can not be modified. Node status is not Inactive.
    </div>
    <div class="tabs-container spaced">
        <button (click)="currentTab = tabRoot" class="tab" [ngClass]="{'invalid': !validRootConfiguration(),
            'active': currentTab === tabRoot}">Node</button>
        <button (click)="currentTab = tabBackend" class="tab" [ngClass]="{'invalid': !validBackendConfiguration(),
            'active': currentTab === tabBackend}">Backend</button>
        <button (click)="currentTab = tabParser" class="tab" [ngClass]="{'invalid': !validParserConfiguration(),
            'active': currentTab === tabParser}">Parser</button>
        <button (click)="currentTab = tabSnmp" class="tab" [ngClass]="{'invalid': !validSnmpConfiguration(),
            'active': currentTab === tabSnmp}">Snmp</button>
        <button (click)="currentTab = tabDetector" class="tab" [ngClass]="{'invalid': !validDetectorConfiguration(),
            'active': currentTab === tabDetector}">Detector</button>
        <button (click)="currentTab = tabDiagnoser" class="tab"
            [ngClass]="{'invalid': !validDiagnoserConfiguration(), 'active': currentTab === tabDiagnoser}">Diagnoser</button>
        <button (click)="currentTab = tabActuator" class="tab"
            [ngClass]="{'active': currentTab === tabActuator}">Actuator</button>
        <button (click)="currentTab = tabDataSources" class="tab" [ngClass]="{'invalid': !validDataSourcesConfiguration(),
            'active': currentTab === tabDataSources}">Data Sources</button>
    </div>
    <div *ngIf="showRootTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span class="nc-sidenav-dot-container bold" [ngClass]="{'invalid': !validBackendConfiguration}">Basic
                configuration<div class="nc-dot"></div></span>
        </div>
        <div class="nc-content">
            <div class="nc-content-fields">
                <div class="nc-field nc-field-row">
                    <mat-checkbox disabled class="d-block" [(ngModel)]="configuration!.docker">Dockerized
                        node</mat-checkbox>
                </div>
                <div class="nc-field">
                    <span>Command timeout</span>
                    <input [disabled]="readMode" type="number" [(ngModel)]="configuration!.commandTimeout"
                        [ngClass]="{'invalid': !configuration!.commandTimeout}" />
                </div>
                <div class="nc-field">
                    <span>IP Address</span>
                    <input disabled [(ngModel)]="configuration!.address" type="string" />
                </div>
                <div class="nc-field">
                    <span>Port</span>
                    <input disabled [(ngModel)]="configuration!.port" type="string" />
                </div>
                <div class="nc-field">
                    <span>Backend Node ID</span>
                    <input disabled [(ngModel)]="configuration!.backendNodeId" type="string" />
                </div>
                <div class="nc-field">
                    <span>Data folder</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.dataFolder"
                        [ngClass]="{'invalid': !configuration!.dataFolder}" type="string" />
                </div>
                <div class="nc-field">
                    <span>Timestamp format</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.timestampFormat" type="string" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showBackendTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span class="nc-sidenav-dot-container bold" [ngClass]="{'invalid': !validBackendConfiguration}">Backend
                <div class="nc-dot"></div>
            </span>
        </div>
        <div class="nc-content">
            <div class="nc-content-fields">
                <div class="nc-field">
                    <span>IP Address</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.backend.address"
                        [ngClass]="{'invalid': !configuration!.backend.address}" type="string" />
                </div>
                <div class="nc-field">
                    <span>Port</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.backend.port"
                        [ngClass]="{'invalid': !configuration!.backend.port}" type="string" />
                </div>
                <div class="nc-field">
                    <span>Connection timeout</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.backend.connectionTimeout" type="number" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showParserTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span (click)="parserCurrentSubtab = parserMainSubtab" (keydown)="parserCurrentSubtab = parserMainSubtab"
                class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validParserConfiguration(),'bold': parserCurrentSubtab === parserMainSubtab}">Parser
                <div *ngIf="parserCurrentSubtab === parserMainSubtab" class="nc-dot"></div>
            </span>
            <span (click)="parserCurrentSubtab = parserSplitSubtab" (keydown)="parserCurrentSubtab = parserSplitSubtab"
                class="nc-sidenav-dot-container" [ngClass]="{'bold': parserCurrentSubtab === parserSplitSubtab}">Split
                <div *ngIf="parserCurrentSubtab === parserSplitSubtab" class="nc-dot"></div>
            </span>
        </div>
        <div class="nc-content">
            <div *ngIf="!!configuration?.parser && parserCurrentSubtab === parserMainSubtab" class="nc-content-fields">
                <div class="nc-field">
                    <span>Deparsing Threshold</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser.deparsingThreshold"
                        [ngClass]="{'invalid': configuration!.parser!.deparsingThreshold === undefined}"
                        type="number" />
                </div>
                <div class="nc-field">
                    <span>Cores</span>
                    <input [disabled]="readMode" type="number" [(ngModel)]="configuration!.parser!.cores"
                        [ngClass]="{'invalid': !configuration!.parser!.cores}" />
                </div>
                <div class="nc-field">
                    <span>Processes</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser!.processes"
                        [ngClass]="{'invalid': !configuration!.parser!.processes}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Max chunk</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser!.maxChunk" type="number" />
                </div>
                <div class="nc-field">
                    <span>Learning percentage</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser!.learningPercentage"
                        [ngClass]="{'invalid': !configuration!.parser!.learningPercentage}" type="number" />
                </div>
                <div class="nc-field">
                    <span>End learning percentage</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser!.endLearningPercentage"
                        [ngClass]="{'invalid': !configuration!.parser!.endLearningPercentage}" type="number" />
                </div>
            </div>
            <div *ngIf="!!configuration?.parser?.split && parserCurrentSubtab === parserSplitSubtab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>Window</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser.split.window" type="number" />
                </div>
                <div class="nc-field">
                    <span>Start</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser.split.start"
                        type="datetime-local" />
                </div>
                <div class="nc-field">
                    <span>End</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.parser.split.end" type="datetime-local" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showSnmpTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span class="nc-sidenav-error">
                <mat-icon>error</mat-icon>
                <span>OID duplication detected</span>
            </span>
            <span (click)="deselectSnmp()" (keydown)="deselectSnmp()" class="nc-sidenav-dot-container bold"
                [ngClass]="{'invalid': !validSnmpConfiguration()}">SNMP<div *ngIf="!snmpItemSelected()" class="nc-dot">
                </div></span>
            <span *ngIf="!readMode" (click)="addSnmpDevice()" (keydown)="addSnmpDevice()" class="nc-add-device">Add
                new device
                <mat-icon>add_circle</mat-icon></span>
            <div *ngFor="let device of configuration?.snmp?.devices; let deviceIndex = index" class="nc-device">
                <span class="nc-sidenav-dot-container" (click)="selectSnmpDevice(device)"
                    (keydown)="selectSnmpDevice(device)"
                    [ngClass]="{'invalid': !validSnmpDevice(device), 'duplicate-oid': deviceWithDuplicateOid(device)}">
                    {{device.name.length !== 0 ? device.name : '\<no name>'}}
                        <div *ngIf="selectedDevice === device && !selectedObject" class="nc-dot"></div>
                        <mat-icon *ngIf="!readMode" (click)="deleteSnmpDevice(deviceIndex)"
                            (keydown)="deleteSnmpDevice(deviceIndex)" class="nc-delete-icon">delete_forever</mat-icon>
                </span>
                <div *ngIf="selectedDevice == device">
                    <span *ngIf="!readMode" (click)="addSnmpObject(device)" (keydown)="addSnmpObject(device)"
                        class="nc-add-object">Add new object
                        <mat-icon>add_circle</mat-icon></span>
                    <div *ngFor="let object of device.objects; let objectIndex = index" class="nc-object">
                        <span (click)="selectSnmpObject(object)" (keydown)="selectSnmpObject(object)"
                            class="nc-sidenav-dot-container"
                            [ngClass]="{'invalid': !validSnmpObject(object), 'duplicate-oid': object.duplicatedOid === true}">
                            {{object.name.length !== 0 ? object.name : '\<no name>'}}
                                <div *ngIf="selectedObject === object" class="nc-dot"></div>
                                <mat-icon *ngIf="!readMode" (click)="deleteSnmpObject(deviceIndex, objectIndex)"
                                    (keydown)="deleteSnmpObject(deviceIndex, objectIndex)"
                                    class="nc-delete-icon">delete_forever</mat-icon>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="nc-content">
            <div *ngIf="configuration && !snmpItemSelected()" class="nc-content-fields">
                <div class="nc-field">
                    <span>Frequency minutes</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.snmp!.frequencyMinutes"
                        [ngClass]="{'invalid': !configuration!.snmp!.frequencyMinutes}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Timeout seconds</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.snmp!.timeoutSeconds"
                        [ngClass]="{'invalid': !configuration!.snmp!.timeoutSeconds}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Records</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.snmp!.records"
                        [ngClass]="{'invalid': !configuration!.snmp!.records}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Separator</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.snmp!.separator"
                        [ngClass]="{'invalid': !configuration!.snmp!.separator}" type="text" />
                </div>
            </div>
            <div *ngIf="!!selectedDevice">
                <button *ngIf="!readMode" class="button mini wide" (click)="openLoadMib()">Load MIB</button>
                <input style="display: none;" #mibFileSelector type="file" accept=".mib" class="file-upload"
                    (change)="mibFileSelected($event)">
            </div>
            <div *ngIf="!!selectedDevice && !selectedObject" class="nc-content-fields">
                <div class="nc-field">
                    <span>Name</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.name"
                        [ngClass]="{'invalid': !selectedDevice.name}" type="text" />
                </div>

                <div class="nc-field">
                    <span>Address</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.address" type="text" />
                </div>
                <div class="nc-field">
                    <span>Community</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.community" type="text" />
                </div>
                <div class="nc-field">
                    <span>Port</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.port" type="text" />
                </div>
                <div class="nc-field">
                    <span>Version</span>
                    <select [disabled]="readMode" [(ngModel)]="selectedDevice.version"
                        [ngClass]="{'invalid': !selectedDevice.version}">
                        <option *ngFor="let versionItem of versions" [ngValue]="versionItem">{{versionItem}}
                        </option>
                    </select>
                </div>
                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>Security level</span>
                    <select [disabled]="readMode" [(ngModel)]="selectedDevice.securityLevel">
                        <option *ngFor="let securityLevel of securityLevels" [ngValue]="securityLevel">
                            {{securityLevel}}
                        </option>
                    </select>
                </div>
                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>Authentication</span>
                    <select [disabled]="readMode" [(ngModel)]="selectedDevice.authentication">
                        <option *ngFor="let authentication of authentications" [ngValue]="authentication">
                            {{authentication}}</option>
                    </select>
                </div>
                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>Authentication phrase</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.authenticationPhrase" type="text" />
                </div>

                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>Privacy phrase</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.privacyPhrase" type="text" />
                </div>
                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>User</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.user" type="text" />
                </div>
                <div *ngIf="selectedDevice.version.toString() === 'V3'" class="nc-field">
                    <span>Context</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedDevice.context" type="text" />
                </div>
            </div>
            <div *ngIf="!!selectedObject" class="nc-content-fields">
                <div class="nc-field">
                    <span>Name</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedObject.name"
                        [ngClass]="{'invalid': !selectedObject.name}" type="text" />
                </div>
                <div class="nc-field">
                    <span class="nc-field-title">OID</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedObject.oid"
                        [ngClass]="{'invalid': !selectedObject.oid || selectedObject.duplicatedOid === true}"
                        type="text" />
                    <span class="nc-field-error" *ngIf="selectedObject.duplicatedOid === true">Duplicated OID</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showDetectorTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span (click)="detectorCurrentSubtab = detectorGeneralSubtab"
                (keydown)="detectorCurrentSubtab = detectorGeneralSubtab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDetectorGeneralConfiguration(), 'bold': detectorCurrentSubtab === detectorGeneralSubtab}">General
                <div *ngIf="detectorCurrentSubtab === detectorGeneralSubtab" class="nc-dot"></div>
            </span>
            <span (click)="detectorCurrentSubtab = detectorStaticCalibrationTab"
                (keydown)="detectorCurrentSubtab = detectorStaticCalibrationTab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDetectorStaticConfiguration(), 'bold': detectorCurrentSubtab === detectorStaticCalibrationTab}">Static
                Calibration<div *ngIf="detectorCurrentSubtab === detectorStaticCalibrationTab" class="nc-dot"></div>
            </span>
            <span (click)="detectorCurrentSubtab = detectorDynamicCalibrationTab"
                (keydown)="detectorCurrentSubtab = detectorDynamicCalibrationTab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDetectorDynamicConfiguration(), 'bold': detectorCurrentSubtab === detectorDynamicCalibrationTab}">Dynamic
                Calibration<div *ngIf="detectorCurrentSubtab === detectorDynamicCalibrationTab" class="nc-dot">
                </div>
            </span>
        </div>
        <div class="nc-content">
            <div *ngIf="!!configuration?.detector && detectorCurrentSubtab === detectorGeneralSubtab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>LV</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.lv"
                        [ngClass]="{'invalid': !configuration!.detector.lv}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Prep</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.prep"
                        [ngClass]="{'invalid': !configuration!.detector.prep}" type="number" />
                </div>
                <div class="nc-field">
                    <span>Phase (1 or 2)</span>
                    <select [disabled]="readMode" [(ngModel)]="configuration!.detector.phase"
                        [ngClass]="{'invalid': !configuration!.detector.phase}">
                        <option [ngValue]="1">Phase 1</option>
                        <option [ngValue]="2">Phase 2</option>
                    </select>
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Method used for generating missing data.">info</mat-icon>
                        MissingDataSelectMethod
                    </span>
                    <select [disabled]="readMode" [(ngModel)]="configuration!.detector.missingDataSelectedMethod"
                        [ngClass]="{'invalid': !configuration!.detector.missingDataSelectedMethod}">
                        <option value="average">average</option>
                        <option value="zero">zero</option>
                    </select>
                </div>
                <div class="nc-field">
                    <span>Anomalous Features Value Percentage</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.anomalousFeaturesValuePercentage"
                        [ngClass]="{'invalid': !configuration!.detector.anomalousFeaturesValuePercentage}"
                        type="number" />
                </div>
                <div class="nc-field">
                    <span>Maximum Anomalous Features</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.maximumAnomalousFeatures"
                        [ngClass]="{'invalid': !configuration!.detector.maximumAnomalousFeatures}" type="number" />
                </div>
            </div>
            <div *ngIf="!!configuration?.detector && detectorCurrentSubtab === detectorStaticCalibrationTab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>Calibration file</span>
                    <input disabled [(ngModel)]="configuration!.detector.staticCalibration.calibrationFile"
                        type="string" />
                </div>
            </div>
            <div *ngIf="!!configuration?.detector && detectorCurrentSubtab === detectorDynamicCalibrationTab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>Observations</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.dynamicCalibration.observations"
                        [ngClass]="{'invalid': !validDynamicObservationsField()}" type="number" />
                    <span class="nc-field-error" *ngIf="!configuration!.detector.lv">General &gt; LV field is not
                        defined
                        yet.</span>
                    <span class="nc-field-subtitle">Must be greater than "General > LV" field + 2</span>
                </div>
                <div class="nc-field">
                    <span>Lambda</span>
                    <input [disabled]="readMode" [(ngModel)]="configuration!.detector.dynamicCalibration.lambda"
                        [ngClass]="{'invalid': !validDynamicLambdaField()}" type="number" min="0" max="1" />
                    <span class="nc-field-subtitle" *ngIf="!validDynamicLambdaField()">Value must be between 0 and
                        1</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showDiagnoserTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span (click)="diagnoserCurrentSubtab = diagnoserDenialOfServiceSubtab"
                (keydown)="diagnoserCurrentSubtab = diagnoserDenialOfServiceSubtab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDiagnoserDenialOfServiceConfiguration(), 'bold': diagnoserCurrentSubtab === diagnoserDenialOfServiceSubtab}">Denial
                of Service
                <div *ngIf="diagnoserCurrentSubtab === diagnoserDenialOfServiceSubtab" class="nc-dot"></div>
            </span>
            <span (click)="diagnoserCurrentSubtab = diagnoserPortScanningSubTab"
                (keydown)="diagnoserCurrentSubtab = diagnoserPortScanningSubTab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDiagnoserPortScanningConfiguration(), 'bold': diagnoserCurrentSubtab === diagnoserPortScanningSubTab}">Port
                Scanning<div *ngIf="diagnoserCurrentSubtab === diagnoserPortScanningSubTab" class="nc-dot"></div>
            </span>
            <span (click)="diagnoserCurrentSubtab = diagnoserDataExfiltrationSubTab"
                (keydown)="diagnoserCurrentSubtab = diagnoserDataExfiltrationSubTab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDiagnoserDataExfiltrationConfiguration(), 'bold': diagnoserCurrentSubtab === diagnoserDataExfiltrationSubTab}">Data
                Exfiltration<div *ngIf="diagnoserCurrentSubtab === diagnoserDataExfiltrationSubTab" class="nc-dot">
                </div>
            </span>
            <span (click)="diagnoserCurrentSubtab = diagnoserSshSubTab"
                (keydown)="diagnoserCurrentSubtab = diagnoserSshSubTab" class="nc-sidenav-dot-container"
                [ngClass]="{'invalid': !validDiagnoserSshConfiguration(), 'bold': diagnoserCurrentSubtab === diagnoserSshSubTab}">Ssh
                <div *ngIf="diagnoserCurrentSubtab === diagnoserSshSubTab" class="nc-dot">
                </div>
            </span>
        </div>
        <div class="nc-content">
            <div *ngIf="!!configuration?.diagnoser && diagnoserCurrentSubtab === diagnoserDenialOfServiceSubtab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Maximum packets per minute allowed">info</mat-icon>
                        Threshold packets per minute</span>
                    <input [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdPacketsPerMinute"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdPacketsPerMinute}"
                        type="number" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Maximum connections per IP">info</mat-icon>
                        Threshold connections per IP</span>
                    <input [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdConnectionsPerIP"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdConnectionsPerIP}"
                        type="number" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Maximum connections with duration zero">info</mat-icon>
                        Threshold connections duration zero</span>
                    <input [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdConnectionsDurationZero"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdConnectionsDurationZero}"
                        type="number" />
                </div>
            </div>
            <div *ngIf="!!configuration?.diagnoser && diagnoserCurrentSubtab === diagnoserDenialOfServiceSubtab">
                <h6 class="mb-1 mt-2">Threshold High Packets Low Duration</h6>
                <div class="nc-content-fields">
                    <div class="nc-field">
                        <span>
                            <mat-icon class="icon-info"
                                title="Maximum allowed threshold meeting the duration and packet conditions">info</mat-icon>
                            Threshold</span>
                        <input
                            [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.threshold"
                            [disabled]="readMode"
                            [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.threshold}"
                            type="number" />
                    </div>
                    <div class="nc-field">
                        <span>
                            <mat-icon class="icon-info" title="Maximum packets to meet condition">info</mat-icon>
                            Packets</span>
                        <input
                            [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.packets"
                            [disabled]="readMode"
                            [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.packets}"
                            type="number" />
                    </div>
                    <div class="nc-field">
                        <span>
                            <mat-icon class="icon-info" title="Minimum duration to meet condition">info</mat-icon>
                            Duration</span>
                        <input
                            [(ngModel)]="configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.duration"
                            [disabled]="readMode"
                            [ngClass]="{'invalid': !configuration!.diagnoser.denialOfService.thresholdHighPacketsLowDuration.duration}"
                            type="number" />
                    </div>
                </div>
            </div>
            <div *ngIf="!!configuration?.diagnoser && diagnoserCurrentSubtab === diagnoserPortScanningSubTab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Maximum number of connections an IP can make to differents ports">info</mat-icon>
                        Threshold max ports</span>
                    <input [(ngModel)]="configuration!.diagnoser.portScanning.thresholdMaxPorts" [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.portScanning.thresholdMaxPorts}"
                        type="number" />
                    <span class="nc-field-subtitle">Threshold max ports and threshold connections per ip are both a
                        condition</span>
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Maximum number of connections an IP can make in a single time window">info</mat-icon>
                        Threshold connections per ip</span>
                    <input [(ngModel)]="configuration!.diagnoser.portScanning.thresholdConnectionsPerIp"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.portScanning.thresholdConnectionsPerIp}"
                        type="number" />
                </div>
            </div>
            <div *ngIf="!!configuration?.diagnoser && diagnoserCurrentSubtab === diagnoserDataExfiltrationSubTab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Maximum packets per conection">info</mat-icon>
                        Threshold Max Packets</span>
                    <input [(ngModel)]="configuration!.diagnoser.dataExfiltration.thresholdMaxPackets"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.dataExfiltration.thresholdMaxPackets}"
                        type="number" />
                    <span class="nc-field-subtitle">Threshold max packets, whitelist ports and threshold are a
                        condition</span>
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Whitelist of ports allowed">info</mat-icon>
                        Ports splitted by comma (,)</span>
                    <input [(ngModel)]="inputWhitelistPorts" (ngModelChange)="updateWhitelistPorts()"
                        [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.dataExfiltration.whitelistPorts}"
                        type="text" />
                    <span>Selected values: <span class="badge"
                            *ngFor="let value of configuration!.diagnoser.dataExfiltration.whitelistPorts">{{value}}</span></span>
                </div>
            </div>
            <div *ngIf="!!configuration?.diagnoser && diagnoserCurrentSubtab === diagnoserSshSubTab"
                class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="The number of connection attempts within the ThresholdTime window">info</mat-icon>
                        Threshold</span>
                    <input [(ngModel)]="configuration!.diagnoser.ssh.threshold" [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.ssh.threshold}" type="number" />
                    <span class="nc-field-subtitle">Threshold and threshold time are both a
                        condition</span>
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="The time interval (in seconds) to consider between successive connection attempts">info</mat-icon>
                        Threshold time</span>
                    <input [(ngModel)]="configuration!.diagnoser.ssh.thresholdTime" [disabled]="readMode"
                        [ngClass]="{'invalid': !configuration!.diagnoser.ssh.thresholdTime}" type="number" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showActuatorTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span (click)="actuatorCurrentSubtab = actuatorHoneyPotSubtab"
                (keydown)="actuatorCurrentSubtab = actuatorHoneyPotSubtab" class="nc-sidenav-dot-container"
                [ngClass]="{'bold': actuatorCurrentSubtab === actuatorHoneyPotSubtab}">HoneyPot
                <div *ngIf="actuatorCurrentSubtab === actuatorHoneyPotSubtab" class="nc-dot"></div>
            </span>
        </div>
        <div class="nc-content">
            <div *ngIf="actuatorCurrentSubtab === actuatorHoneyPotSubtab">
                <h6 class="mb-1 mt-2">SSH</h6>
                <div class="nc-content-fields">
                    <div class="nc-field">
                        <span>
                            <mat-icon class="icon-info" title="Address of HoneyPot">info</mat-icon>
                            Address</span>
                        <input [(ngModel)]="configuration!.actuator!.honeyPot!.ssh!.address" type="string" />
                    </div>
                    <div class="nc-field">
                        <span>
                            <mat-icon class="icon-info" title="Port of HoneyPot">info</mat-icon>
                            Port</span>
                        <input [(ngModel)]="configuration!.actuator!.honeyPot!.ssh!.port" type="number" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showDataSourcesTab()" class="node-configuration-tab">
        <div class="nc-sidenav">
            <span (click)="deselectDataSources()" (keydown)="deselectDataSources()"
                class="nc-sidenav-dot-container bold mb-1"
                [ngClass]="{'invalid': !validDataSourcesConfiguration()}">Data Sources<div *ngIf="!dataSourceSelected()"
                    class="nc-dot"></div></span>
            <div *ngFor="let dataSource of configuration?.dataSources; let dataSourceIndex = index" class="nc-device">
                <span class="nc-sidenav-dot-container" (click)="selectDataSource(dataSource)"
                    (keydown)="selectDataSource(dataSource)" [ngClass]="{'invalid': !validDataSource(dataSource)}">
                    {{dataSource.name.length !== 0 ? dataSource.name : '\<no name>'}}
                        <div *ngIf="selectedDataSource === dataSource && !selectedFeature && !selectedVariable"
                            class="nc-dot"></div>
                </span>
                <div *ngIf="selectedDataSource === dataSource">
                    <div>
                        <span *ngIf="!readMode" (click)="addDataSourceVariable(dataSource)"
                            (keydown)="addDataSourceVariable(dataSource)" class="nc-add-object">Add new variable
                            <mat-icon>add_circle</mat-icon></span>
                        <div *ngFor="let variable of dataSource.configuration.variables; let variableIndex = index"
                            class="nc-object">
                            <span (click)="selectDataSourceVariable(variable)"
                                (keydown)="selectDataSourceVariable(variable)" class="nc-sidenav-dot-container"
                                [ngClass]="{'invalid': !validDataSourceVariable(variable, dataSource)}">
                                {{variable.name.length !== 0 ? variable.name : '\<no name>'}}
                                    <div *ngIf="selectedVariable === variable" class="nc-dot"></div>
                                    <mat-icon *ngIf="!readMode"
                                        (click)="deleteDataSourceVariable(dataSourceIndex, variableIndex)"
                                        (keydown)="deleteDataSourceVariable(dataSourceIndex, variableIndex)"
                                        class="nc-delete-icon">delete_forever</mat-icon>
                            </span>
                        </div>
                    </div>
                    <hr>
                    <div>
                        <span *ngIf="!readMode" (click)="addDataSourceFeature(dataSource)"
                            (keydown)="addDataSourceFeature(dataSource)" class="nc-add-object">Add
                            new feature
                            <mat-icon>add_circle</mat-icon></span>
                        <div *ngFor="let feature of dataSource.configuration.features; let featureIndex = index"
                            class="nc-object">
                            <span (click)="selectDataSourceFeature(feature)"
                                (keydown)="selectDataSourceFeature(feature)" class="nc-sidenav-dot-container"
                                [ngClass]="{'invalid': !validDataSourceFeature(feature)}">
                                {{feature.name.length !== 0 ? feature.name : '\<no name>'}}
                                    <div *ngIf="selectedFeature === feature" class="nc-dot"></div>
                                    <mat-icon *ngIf="!readMode"
                                        (click)="deleteDataSourceFeature(dataSourceIndex, featureIndex)"
                                        (keydown)="deleteDataSourceFeature(dataSourceIndex, featureIndex)"
                                        class="nc-delete-icon">delete_forever</mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nc-content">
            <div *ngIf="dataSourceSelected() && !variableSelected() && !featureSelected()" class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Data source name.">info</mat-icon>
                        Name
                    </span>
                    <input disabled [(ngModel)]="selectedDataSource!.name"
                        [ngClass]="{'invalid': !selectedDataSource!.name}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Pattern for searching this datasource in file system.">info</mat-icon>
                        File pattern
                    </span>
                    <input disabled [(ngModel)]="selectedDataSource!.filePattern" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Specify if data file is structured (csv) or not.">info</mat-icon>
                        Structured
                    </span>
                    <mat-checkbox disabled [(ngModel)]="selectedDataSource!.configuration.structured"
                        [ngClass]="{'invalid': !selectedDataSource!.configuration.structured}" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Directory where .nfcapd is located for transforming it to CSV.">info</mat-icon>
                        WSL directory
                    </span>
                    <input disabled [(ngModel)]="selectedDataSource!.wslDirectory" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Format for timestamp.">info</mat-icon>
                        Timestamp format
                    </span>
                    <input disabled [(ngModel)]="selectedDataSource!.configuration.timestampFormat"
                        [ngClass]="{'invalid': !selectedDataSource!.configuration.timestampFormat}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Name of timestamp variable.">info</mat-icon>
                        Time argument</span>
                    <input disabled [(ngModel)]="selectedDataSource!.configuration.timeArgument"
                        [ngClass]="{'invalid': !selectedDataSource!.configuration.timeArgument}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Character for placing it between data in the same log. By default ','.">info</mat-icon>
                        Separator
                    </span>
                    <input disabled [(ngModel)]="selectedDataSource!.configuration.separator"
                        [ngClass]="{'invalid': !selectedDataSource!.configuration.separator}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Specify if data comes from a nfcapd file for converting it to CSV.">info</mat-icon>
                        Nfcapd
                    </span>
                    <mat-checkbox disabled [(ngModel)]="selectedDataSource!.configuration.nfcapd"
                        [ngClass]="{'invalid': !selectedDataSource!.configuration.nfcapd}" />
                </div>
            </div>
            <div *ngIf="variableSelected()" class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Variable name.">info</mat-icon>
                        Name
                    </span>
                    <input [disabled]="readMode" [(ngModel)]="selectedVariable!.name"
                        [ngClass]="{'invalid': !selectedVariable!.name}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Variable type.">info</mat-icon>
                        Match type
                    </span>
                    <select [disabled]="readMode" [(ngModel)]="selectedVariable!.matchType"
                        [ngClass]="{'invalid': !selectedVariable!.matchType}">
                        <option *ngFor="let type of variableMatchTypes" [value]="type">{{type}}</option>
                    </select>
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Variable position, starting from 0. Only if structured file.">info</mat-icon>
                        Position
                    </span>
                    <input [disabled]="!selectedDataSource?.configuration?.structured || readMode"
                        [(ngModel)]="selectedVariable!.position"
                        [ngClass]="{'invalid': !validDataSourcePosition(selectedVariable!, selectedDataSource!)}"
                        type="number" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info"
                            title="Regular expression for identifying this variable in case of not structured file.">info</mat-icon>
                        Regexp
                    </span>
                    <input [disabled]="!!selectedDataSource?.configuration?.structured || readMode"
                        [(ngModel)]="selectedVariable!.regexp"
                        [ngClass]="{'invalid': !validDataSourceRegexp(selectedVariable!, selectedDataSource!)}"
                        type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Regular expression group if applicable">info</mat-icon>
                        Regexp group
                    </span>
                    <input [disabled]="readMode" [(ngModel)]="selectedVariable!.regexpGroup" type="number" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Variable weight. By default '1'">info</mat-icon>
                        Weight
                    </span>
                    <input [disabled]="readMode" [(ngModel)]="selectedVariable!.regexpGroup" type="number" />
                </div>
            </div>
            <div *ngIf="featureSelected()" class="nc-content-fields">
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Feature name.">info</mat-icon>
                        Name
                    </span>
                    <input [disabled]="readMode" [(ngModel)]="selectedFeature!.name"
                        [ngClass]="{'invalid': !selectedFeature!.name}" type="text" />
                </div>
                <div class="nc-field">
                    <span>
                        <mat-icon class="icon-info" title="Name of the assigned variable.">info</mat-icon>
                        Variable
                    </span>
                    <select [disabled]="readMode" [(ngModel)]="selectedFeature!.variable"
                        [ngClass]="{'invalid': !validDataSourceFeatureVariable(selectedFeature!, selectedDataSource!)}">
                        <option *ngFor="let variableName of getSelectedDataSourceVariableNames()"
                            [value]="variableName">{{variableName}}</option>
                    </select>
                </div>
                <div class="nc-field">
                    <span>Weight</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedFeature!.weight" type="number" />
                </div>
                <div class="nc-field">
                    <span>Match type</span>
                    <select [disabled]="readMode" [(ngModel)]="selectedFeature!.matchType"
                        [ngClass]="{'invalid': !selectedFeature!.matchType}">
                        <option *ngFor="let type of featureMatchTypes" [value]="type">{{type}}</option>
                    </select>
                </div>
                <div class="nc-field" *ngIf="featureMatchTypeNeedsValue(selectedFeature!)">
                    <span>Value</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedFeature!.value"
                        [ngClass]="{'invalid': featureMatchTypeNeedsValue(selectedFeature!) && !selectedFeature!.value}"
                        type="text" />
                </div>
                <div class="nc-field" *ngIf="featureMatchTypeNeedsValues(selectedFeature!)">
                    <span>Values splitted by comma (,)</span>
                    <input [disabled]="readMode" [(ngModel)]="selectedFeature!.frontValues"
                        [ngClass]="{'invalid': featureMatchTypeNeedsValues(selectedFeature!) && !selectedFeature!.frontValues}"
                        type="text" />
                    <span>Selected values: <span class="badge"
                            *ngFor="let value of getSelectedFeatureValues()">{{value}}</span></span>
                </div>
            </div>
        </div>
    </div>
    <div class="nc-action-bar">
        <button [disabled]="working" (click)="returnToNodeManager()" class="button mini wide outline">Cancel</button>
        <button [disabled]="working || !validNodeConfiguration()" (click)="save()"
            class="button mini wide">Save</button>
    </div>
</div>